import Marquee from "react-fast-marquee";
import { Droplets } from "lucide-react";

const ITEMS = [
    "Kayseri Tesisatçı",
    "Kayseri Su Tesisatçısı",
    "Tıkanıklık Açma",
    "Su Kaçağı Tespiti",
    "Kombi Tamiri",
    "Petek Temizliği",
    "Banyo Tesisatı",
    "Mutfak Tesisatı",
    "7/24 Acil Tesisatçı",
    "Tuvalet Tıkanıklığı",
    "Lavabo Tıkanıklığı",
    "Gider Açma",
    "Boru Değişimi",
    "Melikgazi Tesisatçı",
    "Kocasinan Tesisatçı",
    "Talas Tesisatçı",
];

export const Ticker = () => {
    return (
        <div data-testid="services-ticker" className="bg-[#0F172A] text-white py-5 border-y border-slate-800">
            <Marquee gradient={false} speed={45} pauseOnHover>
                {ITEMS.map((item, i) => (
                    <div key={i} className="flex items-center gap-4 px-6">
                        <Droplets className="w-5 h-5 text-[#3D7BFF]" strokeWidth={2.5} />
                        <span className="text-lg sm:text-xl font-extrabold tracking-tight uppercase">
                            {item}
                        </span>
                        <span className="text-[#3D7BFF] text-2xl">•</span>
                    </div>
                ))}
            </Marquee>
        </div>
    );
};

export default Ticker;
